<div class="py-2 px-4">
  <div class="row pb-2 title-bar">
    <div class="col-md-6 col-xl-9">
      <img class="imageAdd" [src]="'/assets/menu/enterprise/select-column-icon.jpg'" />
      <span class="h6">Edit Columns</span>
      <small class="note"> (Choose up to {{maxColumns}} Columns)  </small>
    </div>
    <div class="col-md-6 col-xl-3">
      <button kendoButton class="steps_buttons_class" (click)="_onClose()">
        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
        <span>Close</span>
      </button>
      <button kendoButton class="steps_buttons_class" (click)="_onSave()">
        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
        <span>Save</span>
      </button>
    </div>
  </div>

  <div class="row border-bottom pb-2 title-bar">
    <div class="col-md-6 col-xl-6">
      <label class="SelectedLabel">({{selectedColumns.length}}) Selected</label>
      <input kendoRadioButton type="radio" id="ExpandAll" name="Expand-Collapse" value="Expand All" (click)="_expandAll()" style="padding-left: 5px;" />
      <label class="k-radio-label" [for]="'ExpandAll'" style="padding-right: 5px; font-weight: bold;">
        Expand All
      </label>
      <input kendoRadioButton type="radio" id="CollapseAll" name="Expand-Collapse" value="Collapse All" (click)="_collapseAll()" />
      <label class="k-radio-label" [for]="'CollapseAll'" style="padding-right: 5px; font-weight: bold;">
        Collapse All
      </label>
    </div>
    <div class="col-md-6 col-xl-6">
      <input type="text" class="k-textbox writebox min-width-0 newFormControlWidth searchBox"
        placeholder="Type to Search" [(ngModel)]="_searchValue" [ngModelOptions]="{standalone: true}" (keyup)="doSearch()" />
      </div>
    </div>

    <div class="row row-cols-3 pt-2">
      @for (group of _groupExpandData; track group) {
        <div class="card col-group">
          <div class="group-title" (click)="_toggleExpand(group.groupValue)" style="cursor:pointer">
            {{group.groupValue}} @if (group.selectedCount > 0) {
            <small class="SelectedLabelSmall">( {{group.selectedCount}} ) selected</small>
          }
          <div [ngClass]="_isExpanded(group.groupValue) == true ? 'sort-asc' :  'sort-desc'" (click)="_toggleExpand(group.groupValue)"></div>
        </div>
        @if (_isExpanded(group.groupValue) == true) {
          <div class="px-2 pb-2">
            @for (column of group.items; track column) {
              <div>
                @if (( !_currentUser || _currentUser.isEnterprise || (!_currentUser.isEnterprise && column.field != 'quantityPerAccount') )) {
                  <div>
                    @if (column.id !== 0) {
                      <input type="checkbox" class="k-checkbox" [id]="column.id"
                        [checked]="_isItemSelected(column.id)" (change)="_onItemValueChange($event, column, group.groupValue)">
                    }
                    <label class="k-checkbox-label" for="{{column.id}}">{{ column.gridFieldText?.currentText??column.title }}</label>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
